import { render, staticRenderFns } from "./repairs.vue?vue&type=template&id=567e2b96&"
import script from "./repairs.vue?vue&type=script&lang=js&"
export * from "./repairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports